export const TEXTS = {
  UPLOADING: 'Загружается...',
  ERROR: 'Ошибка загрузки',
};
